import React from 'react';
import { VscEdit, VscError } from 'react-icons/vsc';
import { Button, Spinner, Table } from 'react-bootstrap';
import { SubsidiaryActionModal } from './Subsidiaries/Modals';
import { useSubsidiaries } from '../hooks';

let isCreation = true, subsidiary = null;
const dateFormat = (date) =>
  new Date(date).toLocaleDateString('es-MX', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    weekday: 'long',
  });

const Subsidiaries = ({ title }) => {
  const {
    errorMessage,
    isError,
    isLoading,
    subsidiaries,
    modals,
    closeFormModal,
    openFormModal,
    handleDelete,
    refresh,
  } = useSubsidiaries();

  return (
    <div className="container mt-4">
      {isLoading && (
        <div className="overlay">
          <Spinner animation="border" role="status">
            <span className="sr-only"></span>
          </Spinner>
        </div>
      )}

      {!isError && (
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h1 className="title">{title}</h1>
          <div className="d-flex justify-content-between align-items-end content-buttons">
            <Button
              variant="primary"
              className="btn-primary mx-2px"
              onClick={() => {
                isCreation = true;
                subsidiary = null;
                openFormModal();
              }}
            >
              Agregar nueva sucursal
            </Button>
          </div>
        </div>
      )}
      <div className="table-container">
        {isError ? (
          <div>{errorMessage}</div>
        ) : (
          <>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Nombre</th>
                  <th>Fecha de creación</th>
                  <th>Fecha de actualización</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(subsidiaries) &&
                  subsidiaries.length > 0 ? (
                  subsidiaries.map((sub, i) => {
                    return (
                      <tr key={sub.id}>
                        <td>{i + 1}</td>
                        <td>{sub.name}</td>
                        <td>
                          {dateFormat(
                            sub.createdAt
                          )}
                        </td>
                        <td>
                          {dateFormat(
                            sub.updatedAt
                          )}
                        </td>
                        <td
                          style={{
                            display: 'flex',
                            justifyContent:
                              'space-evenly',
                          }}
                        >
                          <Button
                            style={{
                              display: 'flex',
                              justifyContent:
                                'center',
                              alignItems:
                                'center',
                            }}
                            variant="primary"
                            onClick={() => {
                              isCreation = false;
                              subsidiary = sub;
                              openFormModal();
                            }}
                          >
                            <VscEdit />
                          </Button>
                          <Button
                            style={{
                              display: 'flex',
                              justifyContent:
                                'center',
                              alignItems:
                                'center',
                            }}
                            variant="primary"
                            onClick={() =>
                              handleDelete(sub.id)
                            }
                          >
                            <VscError />
                          </Button>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center">
                      No hay sucursales aún.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
            <SubsidiaryActionModal
              show={modals.subForm}
              isLoading={isLoading}
              onHide={closeFormModal}
              isCreation={isCreation}
              subsidiary={subsidiary}
              refresh={refresh}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default Subsidiaries;
